<div [class.dark]="darkBackground">
  @if (!blockEmbedAssetView) {
    <div class="assets-section" [style.maxWidth]="embedMode ? '' : sectionWidth + 'px'">
      <div #assetGallery class="assets" [style.height]="sectionHeight + 'px'">
        @for (item of visibleItems; track item.asset.id) {
          <a
            class="asset"
            [class.with-bg]="
              item.asset.type !== 'image' || !(item.asset.version_data.asset_name | assetSupportsTransparency)
            "
            [routerLink]="[item.asset.id]"
            [queryParams]="queryParams"
            id="asset-{{ item.asset.id }}"
            [style.width]="item.dimensions.width + 'px'"
            [style.height]="item.dimensions.height + 'px'"
            [style.left]="item.dimensions.x + 'px'"
            [style.top]="item.dimensions.y + 'px'"
            (mouseenter)="hoverItem = item"
            (mouseleave)="hoverItem = undefined"
            (contextmenu)="assetRightClick(item.asset, $event)"
            appInferredHover="asset-{{ item.asset.id }}"
            (onInferredHoverChange)="hoverContextOpenItem = $event ? item : undefined"
            draggable="false"
          >
            @if (
              isDesktop &&
              (hoverItem === item || hoverContextOpenItem === item) &&
              (item.asset | canDownloadAsset: gallery : accessLevel)
            ) {
              <app-asset-download-button
                [@assetDownloadButton]
                location="assets-section"
                [accessLevel]="accessLevel"
                [asset]="item.asset"
                [gallery]="gallery"
                [previewWidth]="item.dimensions.width"
                (click)="downloadClick($event)"
              >
                <button
                  appButton
                  name="download"
                  location="assets-section"
                  [iconButton]="true"
                  color="dark-blur"
                  shape="round"
                  height="-1"
                >
                  <app-svg src="/assets/icons/download.svg" color="grey-30"></app-svg>
                </button>
              </app-asset-download-button>
            }

            <app-layout-asset
              [asset]="item.asset"
              [gallery]="gallery"
              [hovering]="hoverItem === item || hoverContextOpenItem === item"
              [isDesktop]="isDesktop"
              [dimensions]="item.dimensions"
              [accessLevel]="accessLevel"
              [approvedAssetCount]="approvedAssetCount"
              [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions"
              [approvedAssetCount]="approvedAssetCount"
            ></app-layout-asset>
            @if (section.show_filenames) {
              <div class="asset-name" (click)="assetNameClick($event)">{{ item.asset.version_data.asset_name }}</div>
            }
          </a>
        }
      </div>
    </div>
  }
  @if (blockEmbedAssetView) {
    <div class="assets-section" [style.maxWidth]="embedMode ? '' : sectionWidth + 'px'">
      <div #assetGallery class="assets" [style.height]="sectionHeight + 'px'">
        @for (item of visibleItems; track item.asset.id) {
          <div
            class="asset"
            [class.with-bg]="
              item.asset.type !== 'image' || !(item.asset.version_data.asset_name | assetSupportsTransparency)
            "
            id="asset-{{ item.asset.id }}"
            [style.width]="item.dimensions.width + 'px'"
            [style.height]="item.dimensions.height + 'px'"
            [style.left]="item.dimensions.x + 'px'"
            [style.top]="item.dimensions.y + 'px'"
            (mouseenter)="hoverItem = item"
            (mouseleave)="hoverItem = undefined"
          >
            <app-layout-asset
              [asset]="item.asset"
              [gallery]="gallery"
              [hovering]="hoverItem?.asset.id === item.asset.id"
              [isDesktop]="isDesktop"
              [dimensions]="item.dimensions"
              [accessLevel]="accessLevel"
              [approvedAssetCount]="approvedAssetCount"
            ></app-layout-asset>
            @if (section.show_filenames) {
              <div class="asset-name" (click)="assetNameClick($event)">{{ item.asset.version_data.asset_name }}</div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (!visibleItems) {
    <div class="fake-assets page">
      <div class="fake-asset"></div>
      <div class="fake-asset"></div>
      <div class="fake-asset"></div>
      <div class="fake-asset"></div>
      <div class="fake-asset"></div>
      <div class="fake-asset"></div>
      <div class="fake-asset"></div>
      <div class="fake-asset"></div>
      <div class="fake-asset"></div>
    </div>
  }
</div>
